import axios from "axios";
import { getBackendUrl, getEnvToken } from "../config";

const api = axios.create({
  baseURL: getBackendUrl(),
  withCredentials: true
});

const injectAuthHeader = config => {
  if (typeof window === "undefined") {
    return config;
  }

  try {
    const storedToken = window.localStorage.getItem("token");
    if (!storedToken) {
      return config;
    }

    let parsedToken = storedToken;
    try {
      parsedToken = JSON.parse(storedToken);
    } catch {
      parsedToken = storedToken;
    }

    if (parsedToken) {
      config.headers = config.headers || {};
      // ✅ CORREÇÃO: Garantir que o token seja enviado mesmo para URLs absolutas
      // O axios aplica o interceptor mesmo quando a URL é absoluta e diferente do baseURL
      config.headers.Authorization = `Bearer ${parsedToken}`;
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[api] Falha ao recuperar token do localStorage", err);
  }

  return config;
};

api.interceptors.request.use(injectAuthHeader, error => Promise.reject(error));

export const openApi = axios.create({
  baseURL: getBackendUrl()
});

openApi.interceptors.request.use(
  (config) => {
    const token = getEnvToken();
    if (token) {
      config.params = { ...(config.params || {}), token };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
